import 'simplebar-react/dist/simplebar.min.css'

import { useEffect, useState } from 'react'
import { FiHeart, FiMessageCircle, FiSearch, FiShare, FiStar, FiX } from 'react-icons/fi'
import SimpleBar from 'simplebar-react'

import ChatHeader from '@/components/ChatHeader'

const TABS = ['学习', '创作', '工作', '生活', '贴吧', '广场', '评画', '视频', '报考', '动漫', '创意', '留学']

const MOCK_DATA = [
  {
    id: 1,
    image: 'https://images.unsplash.com/photo-1513364776144-60967b0f800f?w=500&q=80',
    avatar: 'https://i.pravatar.cc/150?u=1',
    username: '爱画画的小李',
    usage: '8.5万人使用',
    height: 'h-64'
  },
  {
    id: 2,
    image: 'https://images.unsplash.com/photo-1542831371-29b0f74f9713?w=500&q=80',
    avatar: 'https://i.pravatar.cc/150?u=2',
    username: '清风徐来',
    usage: '19.2万人使用',
    height: 'h-80'
  },
  {
    id: 4,
    image: 'https://images.unsplash.com/photo-1544928147-79a2dbc1f389?w=500&q=80',
    avatar: 'https://i.pravatar.cc/150?u=4',
    username: '调色盘里',
    usage: '1.9万人使用',
    height: 'h-72'
  },
  {
    id: 5,
    image: 'https://images.unsplash.com/photo-1536924940846-227afb31e2a5?w=500&q=80',
    avatar: 'https://i.pravatar.cc/150?u=5',
    username: '光影收藏家',
    usage: '6.1万人使用',
    height: 'h-64'
  },
  {
    id: 6,
    image: 'https://images.unsplash.com/photo-1460661419201-fd4cecdf8a8b?w=500&q=80',
    avatar: 'https://i.pravatar.cc/150?u=6',
    username: '绘素描',
    usage: '1小时前',
    height: 'h-80'
  },
  {
    id: 7,
    image: 'https://images.unsplash.com/photo-1513364776144-60967b0f800f?w=500&q=80',
    avatar: 'https://i.pravatar.cc/150?u=7',
    username: 'Evan同学',
    usage: '14小时前',
    height: 'h-56'
  },
  {
    id: 8,
    image: 'https://images.unsplash.com/photo-1542831371-29b0f74f9713?w=500&q=80',
    avatar: 'https://i.pravatar.cc/150?u=8',
    username: '美术宝创作老师',
    usage: '56万人使用',
    height: 'h-72'
  },
  {
    id: 10,
    image: 'https://images.unsplash.com/photo-1544928147-79a2dbc1f389?w=500&q=80',
    avatar: 'https://i.pravatar.cc/150?u=10',
    username: '卡皮巴拉的小窝',
    usage: '5.8万人使用',
    height: 'h-80'
  },
  {
    id: 11,
    image: 'https://images.unsplash.com/photo-1536924940846-227afb31e2a5?w=500&q=80',
    avatar: 'https://i.pravatar.cc/150?u=11',
    username: '画笔飞舞',
    usage: '1.2万人使用',
    height: 'h-64'
  },
  {
    id: 12,
    image: 'https://images.unsplash.com/photo-1460661419201-fd4cecdf8a8b?w=500&q=80',
    avatar: 'https://i.pravatar.cc/150?u=12',
    username: '色彩大师',
    usage: '3.4万人使用',
    height: 'h-72'
  },
  {
    id: 13,
    image: 'https://images.unsplash.com/photo-1460661419201-fd4cecdf8a8b?w=500&q=80',
    avatar: 'https://i.pravatar.cc/150?u=13',
    username: '色彩大师',
    usage: '3.4万人使用',
    height: 'h-72'
  }
]

export default function ChatForum() {
  const [activeTab, setActiveTab] = useState('学习')
  const [selectedItem, setSelectedItem] = useState<(typeof MOCK_DATA)[0] | null>(null)

  // Handle ESC key to close modal
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && selectedItem) {
        setSelectedItem(null)
      }
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [selectedItem])

  return (
    <div className="flex flex-1 flex-col overflow-hidden bg-white transition-all duration-300">
      <ChatHeader showTitle={false} showResourcePreview={false} />

      <div className="flex-1 overflow-y-auto">
        <div className="mx-auto w-full max-w-[1200px] px-4 py-6 md:px-6 lg:px-8">
          {/* Header Section: Tabs and Search */}
          <div className="mb-6 flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
            {/* Tabs */}
            <SimpleBar className="flex-1 pb-3" autoHide={false}>
              <div className="flex gap-2">
                {TABS.map((tab) => (
                  <button
                    key={tab}
                    onClick={() => setActiveTab(tab)}
                    className={`shrink-0 whitespace-nowrap rounded-full px-5 py-1.5 text-sm font-medium transition-colors ${
                      activeTab === tab ? 'bg-blue-600 text-white' : 'border border-gray-100 bg-white text-gray-600 hover:bg-gray-50'
                    }`}
                  >
                    {tab}
                  </button>
                ))}
              </div>
            </SimpleBar>

            {/* Search */}
            <div className="relative w-full shrink-0 lg:w-64">
              <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                <FiSearch className="h-4 w-4 text-gray-400" />
              </div>
              <input
                type="text"
                className="block w-full rounded-full border-0 bg-gray-100 py-1.5 pl-10 pr-4 text-sm text-gray-900 placeholder:text-gray-400 focus:bg-white focus:ring-2 focus:ring-inset focus:ring-blue-600"
                placeholder="搜索相关"
              />
            </div>
          </div>

          {/* Grid Layout */}
          <div className="grid grid-cols-2 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5">
            {MOCK_DATA.map((item) => (
              <div key={item.id} className="group flex cursor-pointer flex-col gap-2" onClick={() => setSelectedItem(item)}>
                <div className="relative overflow-hidden rounded-2xl">
                  {/* Image */}
                  <img src={item.image} alt={item.username} className="aspect-[3/4] w-full object-cover transition-transform duration-300 group-hover:scale-105" />

                  {/* Overlay (optional, for hover effects if needed) */}
                  <div className="absolute inset-0 bg-black/5 opacity-0 transition-opacity group-hover:opacity-100" />
                </div>

                {/* Info */}
                <div className="flex items-center justify-between px-1">
                  <div className="flex items-center gap-2">
                    <img src={item.avatar} alt={item.username} className="h-5 w-5 rounded-full object-cover" />
                    <span className="text-xs font-medium text-gray-700">{item.username}</span>
                  </div>
                  <span className="text-[10px] text-gray-400">{item.usage}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Preview Modal */}
      {selectedItem && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm transition-all md:p-8 lg:p-12" onClick={() => setSelectedItem(null)}>
          <div
            className="relative flex h-full w-full flex-col overflow-hidden bg-white md:h-[85vh] md:max-h-[800px] md:w-[90vw] md:max-w-[1200px] md:flex-row md:rounded-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            {/* PC Left: Image Section (Hidden on mobile, shown on md+) */}
            <div className="relative hidden h-full w-[55%] shrink-0 items-center justify-center bg-black md:flex lg:w-[60%]">
              {/* PC Close Button (Top Left of Image) */}
              <button
                className="absolute left-4 top-4 z-10 flex h-10 w-10 items-center justify-center rounded-full bg-black/20 text-white backdrop-blur-md transition-colors hover:bg-black/40"
                onClick={() => setSelectedItem(null)}
              >
                <FiX className="h-6 w-6" />
              </button>

              <img src={selectedItem.image} alt={selectedItem.username} className="h-full w-full object-contain" />
            </div>

            {/* Right/Mobile Full: Content Section */}
            <div className="flex flex-1 flex-col overflow-hidden bg-white">
              {/* Header (Fixed) */}
              <div className="flex shrink-0 items-center justify-between border-b border-gray-100 p-3 sm:p-4">
                <div className="flex items-center gap-2 sm:gap-3">
                  {/* Mobile Back Button (Shown only on mobile) */}
                  <button className="flex h-8 w-8 items-center justify-center text-gray-600 md:hidden" onClick={() => setSelectedItem(null)}>
                    <FiX className="h-6 w-6" />
                  </button>
                  <img src={selectedItem.avatar} alt={selectedItem.username} className="h-8 w-8 rounded-full object-cover sm:h-10 sm:w-10" />
                  <div>
                    <div className="text-sm font-medium text-gray-900">{selectedItem.username}</div>
                    <div className="text-xs text-gray-500">{selectedItem.usage}</div>
                  </div>
                </div>
                <button className="rounded-full bg-blue-600 px-4 py-1.5 text-xs font-medium text-white transition-colors hover:bg-blue-700 sm:px-5 ">开始创作</button>
              </div>

              {/* Scrollable Area (Image + Comments on mobile, only Comments on PC) */}
              <div className="flex-1 overflow-y-auto">
                {/* Mobile Image (Shown only on mobile) */}
                <div className="relative block w-full bg-black md:hidden">
                  <img src={selectedItem.image} alt={selectedItem.username} className="w-full object-contain" />
                </div>

                {/* Comments Area */}
                <div className="p-4">
                  <div className="mb-6 text-xs text-gray-500">共 29 条评论</div>

                  {/* Mock Comment 1 */}
                  <div className="mb-6 flex gap-3">
                    <img src="https://i.pravatar.cc/150?u=13" alt="avatar" className="h-8 w-8 shrink-0 rounded-full object-cover" />
                    <div className="flex-1">
                      <div className="flex items-center gap-2">
                        <span className="text-sm font-medium text-gray-700">友情岁月</span>
                        <span className="rounded bg-red-100 px-1.5 py-0.5 text-[10px] text-red-600">作者</span>
                      </div>
                      <p className="mt-1.5 text-sm leading-relaxed text-gray-800">
                        老师您好！这幅画是我模拟考试的作品，自己看总觉得画面有点平，缺乏层次感。希望您能指点一下如何增强画面张力，还有哪些地方需要调整？
                      </p>
                      <div className="mt-2 flex items-center gap-4 text-xs text-gray-400">
                        <span>1分钟前 · 北京</span>
                        <button className="flex items-center gap-1 hover:text-gray-600">
                          <FiHeart /> 1093
                        </button>
                        <button className="flex items-center gap-1 hover:text-gray-600">
                          <FiMessageCircle /> 317
                        </button>
                      </div>

                      {/* Nested Reply */}
                      <div className="mt-4 flex gap-2">
                        <img src="https://i.pravatar.cc/150?u=14" alt="avatar" className="h-6 w-6 shrink-0 rounded-full object-cover" />
                        <div>
                          <div className="text-xs font-medium text-gray-700">小明同学</div>
                          <p className="mt-1 text-xs text-gray-800">老师评价太到位了</p>
                          <div className="mt-1.5 flex items-center gap-4 text-[10px] text-gray-400">
                            <span>2小时前 · 上海</span>
                            <button className="flex items-center gap-1 hover:text-gray-600">
                              <FiHeart /> 37
                            </button>
                            <button className="flex items-center gap-1 hover:text-gray-600">
                              <FiMessageCircle /> 回复
                            </button>
                          </div>
                        </div>
                      </div>
                      <button className="mt-3 text-xs font-medium text-blue-600 hover:text-blue-700">展开 10 条回复</button>
                    </div>
                  </div>

                  {/* Mock Comment 2 */}
                  <div className="mb-6 flex gap-3">
                    <img src="https://i.pravatar.cc/150?u=13" alt="avatar" className="h-8 w-8 shrink-0 rounded-full object-cover" />
                    <div className="flex-1">
                      <div className="flex items-center gap-2">
                        <span className="text-sm font-medium text-gray-700">友情岁月</span>
                        <span className="rounded bg-red-100 px-1.5 py-0.5 text-[10px] text-red-600">作者</span>
                      </div>
                      <p className="mt-1.5 text-sm leading-relaxed text-gray-800">
                        老师您好！这幅画是我模拟考试的作品，自己看总觉得画面有点平，缺乏层次感。希望您能指点一下如何增强画面张力，还有哪些地方需要调整？
                      </p>
                      <div className="mt-2 flex items-center gap-4 text-xs text-gray-400">
                        <span>1分钟前 · 北京</span>
                        <button className="flex items-center gap-1 hover:text-gray-600">
                          <FiHeart /> 1093
                        </button>
                        <button className="flex items-center gap-1 hover:text-gray-600">
                          <FiMessageCircle /> 317
                        </button>
                      </div>

                      {/* Nested Reply */}
                      <div className="mt-4 flex gap-2">
                        <img src="https://i.pravatar.cc/150?u=14" alt="avatar" className="h-6 w-6 shrink-0 rounded-full object-cover" />
                        <div>
                          <div className="text-xs font-medium text-gray-700">小明同学</div>
                          <p className="mt-1 text-xs text-gray-800">老师评价太到位了</p>
                          <div className="mt-1.5 flex items-center gap-4 text-[10px] text-gray-400">
                            <span>2小时前 · 上海</span>
                            <button className="flex items-center gap-1 hover:text-gray-600">
                              <FiHeart /> 37
                            </button>
                            <button className="flex items-center gap-1 hover:text-gray-600">
                              <FiMessageCircle /> 回复
                            </button>
                          </div>
                        </div>
                      </div>
                      <button className="mt-3 text-xs font-medium text-blue-600 hover:text-blue-700">展开 10 条回复</button>
                    </div>
                  </div>
                </div>
              </div>

              {/* Bottom Input Area (Fixed) */}
              <div className="shrink-0 border-t border-gray-100 bg-white p-3 sm:p-4">
                <div className="flex items-center gap-3 sm:gap-4">
                  <div className="flex h-9 flex-1 items-center gap-2 rounded-full bg-gray-100 px-4 text-sm text-gray-500 sm:h-10">
                    <img src="https://i.pravatar.cc/150?u=me" alt="my avatar" className="h-5 w-5 rounded-full object-cover sm:h-6 sm:w-6" />
                    <input type="text" placeholder="说点什么..." className="w-full bg-transparent outline-none placeholder:text-gray-400" />
                  </div>
                  <div className="flex shrink-0 items-center gap-3 text-gray-600 sm:gap-5">
                    <button className="flex items-center gap-1 hover:text-gray-900">
                      <FiHeart className="h-5 w-5 sm:h-6 sm:w-6" />
                      <span className="hidden text-xs sm:inline">37</span>
                    </button>
                    <button className="flex items-center gap-1 hover:text-gray-900">
                      <FiStar className="h-5 w-5 sm:h-6 sm:w-6" />
                      <span className="hidden text-xs sm:inline">480</span>
                    </button>
                    <button className="flex items-center gap-1 hover:text-gray-900">
                      <FiMessageCircle className="h-5 w-5 sm:h-6 sm:w-6" />
                      <span className="hidden text-xs sm:inline">1392</span>
                    </button>
                    <button className="hover:text-gray-900">
                      <FiShare className="h-5 w-5 sm:h-6 sm:w-6" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
